/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";
import "../../App.css";
import LangContext from "../../contextProvider/LangContext";
import PageToolbar from "../../components/PageToolbar";
import { Button, Card, Row, Col, Form, Icon, Input, InputNumber, message, Tooltip, Radio } from "antd";
import GenericSelectorBranches from "../../components/GenericSelectorBranches";
import { Job, OutputType, ProcessType, User } from "../../JmReact";
import GenericModal from "../../components/GenericModal";
import ResponsiveTable from "../../components/ResponsiveTable";
import ReportShowButton from "../../components/ReportShowButton";
import moment from "moment";
import SelectorZBranchList from "../../components/SelectorZBranchList";
import GenericTable from "../../components/GenericTable";
import TableLineIcons from "../../components/TableLineIcons";
import TableIDs from "../../data/TableIDs";
import GenericSelector from "../../components/GenericSelector";
import ReportTypeButton from "../../components/ReportTypeButton";

class TipsDisplay extends Component {
    constructor(props: Props) {
        super(props);
        this.state = {
            _branchId: '',
            _branchName: '',
            _fromZ: '',
            _toZ: '',
            _fromZStart: null,
            _fromZEnd: null,
            _toZStart: null,
            _toZEnd: null,

            btnZ: '',
            zListData: [],
            inputZFocus: null, // "from" / "to"

            // modals
            modalOpen: false,
            modalDetail: null,      // { rows: [], zNum, dateFrom, dateTo }
            modalViewDoc: null,     // { docs: [], custName }

            modalReport: false,
            modalReportParams: {
                _employeeList: '',
                _tablesList: '',
                _fromSum: null,
                _toSum: null,
                _centralType: '1',
                _splitType: '1',
                reportName: "reports/TipsDisplay.pdf",
            },

        };

        this.id = "TIPS_DISPLAY";
        this.detail_id = "TIPS_DETAIL";
        this.id_list = 'Z_BRANCH_DOCS_BEFORE_CLOSE';

        this.api = {
            get: "get_tips_display",
            get_detail: "get_tips_detail",
        };

        this.selectors = [
            { id: TableIDs.genericSelectorEmployees, api: "get_employee_list" },
            { id: "CUST_TABLES_LIST", api: "cust_tables_list" },
        ]

        if (props.data[this.id] === undefined) props.data[this.id] = { ...props.data.genericData };
        if (props.data[this.detail_id] === undefined) props.data[this.detail_id] = { ...props.data.genericData };
        if (props.data[this.id_list] === undefined) props.data[this.id_list] = { dataset: [] }

        this.selectors.forEach(x => { if (props.data[x.id] === undefined) props.data[x.id] = { ...props.data.genericSelector } })


    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']';
    }

    componentDidUpdate(prevProps) {
        document.title = "Cash On Tab - " + this.getText(22529);

        if (prevProps.ui.favoriteParams !== this.props.ui.favoriteParams) {
            this.setState({ modalReportParams: { ...this.state.modalReportParams, ...this.props.ui.favoriteParams } })
        }
    }

    sendAPI = (script, data, sCal) => {
        let user = new User(this.props.user.token, this.props.user.companyCode);
        let job = new Job(user, script, OutputType.OUTPUT_TYPE_DATA, ProcessType.PROCESS_TYPE_SYNC);
        job.setInput(data);
        job.send("/cgi-bin/CashOnTab", sCal, (e) => { console.error(e) });
    }

    // ─── Z-range shortcuts ───────────────────────────────────────────────────
    zSetValues = (from, to, btnZ) => {
        let res = {
            _fromZ: from.num,
            _toZ: to.num,
            _fromZStart: moment(from.start).format("YYYY-MM-DD"),
            _fromZEnd: moment(from.end).format("YYYY-MM-DD"),
            _toZStart: moment(to.start).format("YYYY-MM-DD"),
            _toZEnd: moment(to.end).format("YYYY-MM-DD"),
            btnZ,
            inputZFocus: null
        };
        if (parseInt(from.num) > parseInt(to.num)) {
            res._fromZ = to.num;
            res._toZ = from.num;
            res._fromZStart = moment(from.start).format("YYYY-MM-DD");
            res._fromZEnd = moment(from.end).format("YYYY-MM-DD");
            res._toZStart = moment(to.start).format("YYYY-MM-DD");
            res._toZEnd = moment(to.end).format("YYYY-MM-DD");
        }
        if (res._fromZ && res._toZ && moment(res._fromZStart).add(1, "year") < moment(res._toZEnd)) {
            message.error(this.getText(22551));
        } else {
            this.setState(res);
        }
    }

    fillLastZ = () => {
        const { _branchId, zListData } = this.state;
        let findLast = zListData.find(f => f.branch == _branchId);
        if (!findLast) return;
        this.zSetValues(findLast, findLast, 'last');
    }

    fillCurrentMonthZ = () => {
        const { _branchId, zListData } = this.state;
        let fitered = zListData.filter(f => f.branch == _branchId && moment(f.start, "YYYY-MM-DD").isSame(moment(), "month"));
        if (!fitered[0]) return;
        let _fromZ = fitered[0];
        let _toZ = fitered[fitered.length - 1];
        this.zSetValues(_fromZ, _toZ, 'curMonth');
    }

    fillPrevMonthZ = () => {
        const { _branchId, zListData } = this.state;
        let fitered = zListData.filter(f => f.branch == _branchId && moment(f.start, "YYYY-MM-DD").isSame(moment().subtract(1, "month"), "month"));
        if (!fitered[0]) return;
        let _fromZ = fitered[0];
        let _toZ = fitered[fitered.length - 1];
        this.zSetValues(_fromZ, _toZ, 'prevMonth');
    }

    renderDetailBtn = (text, record) => {
        return (<TableLineIcons
            genericIcons={[
                {
                    type: "table",
                    tooltip: this.getText(22566),
                    onClick: () => { this.setState({ modalDetail: record }) }
                }, {
                    type: "eye",
                    tooltip: this.getText(22805),
                    onClick: () => {
                        this.sendAPI("get_z_branch_docs", { _branch: this.state._branchId, _num: record.zNumber }, ob => {
                            let dataset = this.datasetBuilder(ob.data)
                            this.setState({ modalViewList: record }, () => { this.props.dataActions.setJson(this.id_list, { dataset }) })
                        })
                    }
                }, {
                    type: "printer",
                    tooltip: this.getText(22806),
                    onClick: () => {
                        let params = {
                            zNumber: record.zNumber,
                            dateFrom: record.minDatetime?.split(" ")[0],
                            dateTo: record.maxDatetime?.split(" ")[0],
                            branchList: this.state._branchId,
                            compDetaild: 1,
                            taxesView: 1,
                            centralType: 8,
                            payTypeList: '',
                            payItemList: '',
                            payItemsSumType: '1',
                            orderSuppliers: '',
                            reportName: "reports/Report80PaymentsAnalysisOneBranch.pdf",
                            PosId: 999,
                            addHours: '00:00:00',
                        };
                        this.props.ActionQueue.addToQueue({ action: this.props.dataActions.generateReport, args: [this.props.user.companyCode, this.props.user.token, params] });
                    }
                },
            ]}
        />)
    }

    renderViewDocBtn = (text, record) => {
        const { dId, dRef2, dCustId, dNum } = record;
        const { headers, data } = this.props.data[this.detail_id]
        let moreDocs = dRef2 ?
            data.map(x => {
                let y = x.split("\f");
                let obj = {}
                headers.forEach((h, i) => { obj[h] = y[i] })
                return obj;
            }).filter(x => x.dRef2 === dRef2 && x.dCustId === dCustId)
            : [record];

        if (moreDocs.length === 1) {
            // no more docs, open the single doc directly
            return this.renderShowBtn(text, record);
        } else {
            return (<TableLineIcons genericIcons={[{ type: "eye", onClick: () => { this.setState({ modalViewDoc: moreDocs }) } }]} />)
        }
    }

    renderShowBtn = (text, record) => {
        return (<ReportShowButton
            {...this.props}
            iconButton
            validSubmit
            params={{
                DocumentNumber: record.dNumber,
                DocumentTypeID: record.dType,
                DocumentPOSID: record.dPos,
                userID: this.props.user.userId,
                userName: encodeURIComponent(this.props.user.displayName),
                isOriginal: '0',
                CentralFatherItem: '0',
                reportName: "reports/DocumentCopy.pdf"
            }}
        />)
    }

    formatSum = (n) => {
        if (!n) return "0.00";
        return parseFloat(n).toLocaleString("he-IL", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    formatQty = (n) => {
        if (!n) return "0";
        return parseInt(n).toLocaleString("he-IL", { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    }

    formatDateDow = (dt) => {
        if (!dt) return "";
        const m = moment(dt);
        const dow = 'אבגדהוש'.split("")[m.day()];
        return m.format("DD/MM/YYYY") + " " + dow + "'";
    }

    formatDateTime = (dt) => {
        if (!dt) return "";
        return moment(dt).format("DD/MM/YYYY HH:mm");
    }

    datasetBuilder = (data) => {
        let dataset = []
        const checkIfAfter = (dt1, dt2) => moment(dt1, 'YYYY-MM-DD HH:mm:ss').isAfter(moment(dt2, 'YYYY-MM-DD HH:mm:ss'))
        data.split("\r").forEach(x => {
            const [_POSID, _POSName, _TypeID, _TypeName, _minTimestamp, _maxTimestamp, _minNumber, _maxNumber] = x.split("\f")
            let findInDataset = dataset.findIndex(y => y.id == _POSID)
            if (findInDataset > -1) {
                dataset[findInDataset] = {
                    ...dataset[findInDataset],
                    types: [...dataset[findInDataset].types, { _TypeID, _TypeName, _minTimestamp, _maxTimestamp, _minNumber, _maxNumber }],
                    min: checkIfAfter(dataset[findInDataset].min, _minTimestamp) ? _minTimestamp : dataset[findInDataset].min,
                    max: checkIfAfter(_maxTimestamp, dataset[findInDataset].max) ? _maxTimestamp : dataset[findInDataset].max
                }
            } else {
                dataset = [
                    ...dataset,
                    {
                        id: _POSID,
                        name: _POSName,
                        types: [{ _TypeID, _TypeName, _minTimestamp, _maxTimestamp, _minNumber, _maxNumber }],
                        min: _minTimestamp,
                        max: _maxTimestamp
                    }
                ]
            }
        })
        return dataset
    }

    render() {
        const gt = this.getText;

        const { _branchId, _fromZ, _toZ, modalOpen, modalDetail, modalViewDoc } = this.state;

        const divStyle = {
            align: "center",
            dir: "rtl",
            padding: "2% 2% 2% 2%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            flexDirection: "column",
        };

        const contentStyle = (<>
            <Form.Item label={gt(22530)} >
                <GenericSelectorBranches
                    {...this.props}
                    value={_branchId}
                    onChange={() => { }}
                    onChangeGetDetailed={({ code, name }) => {
                        this.setState({ _branchId: code, _branchName: name }, this.fillLastZ)
                    }}
                />
            </Form.Item>
            <Form.Item label={gt(22531)} >
                <Icon type="unordered-list" style={{ marginRight: 8 }} onClick={() => this.setState({ inputZFocus: "from" })} />
                <Input style={{ width: 120, display: "inline-block" }} disabled={!_branchId} value={_fromZ} />
                {_fromZ ? <>{" "}  מ  {this.formatDateDow(this.state._fromZStart)} עד {this.formatDateDow(this.state._fromZEnd)}</> : null}
            </Form.Item>
            <Form.Item label={gt(22532)} >
                <Icon type="unordered-list" style={{ marginRight: 8 }} onClick={() => this.setState({ inputZFocus: "to" })} />
                <Input style={{ width: 120, display: "inline-block" }} disabled={!_branchId} value={_toZ} />
                {_toZ ? <>{" "}   מ   {this.formatDateDow(this.state._toZStart)} עד {this.formatDateDow(this.state._toZEnd)}</> : null}
            </Form.Item>

            <Form.Item>
                <Row>
                    {[
                        { key: "last", text: gt(22533), onClick: this.fillLastZ },
                        { key: "curMonth", text: gt(22534), onClick: this.fillCurrentMonthZ },
                        { key: "prevMonth", text: gt(22535), onClick: this.fillPrevMonthZ },
                    ].map(btn => (
                        <Col span={8} key={btn.key}>
                            <div style={{ textAlign: "center" }}>
                                <Button
                                    disabled={!_branchId}
                                    type={this.state.btnZ === btn.key ? 'primary' : 'default'}
                                    onClick={() => this.setState({ btnZ: btn.key }, btn.onClick)}>
                                    {btn.text}
                                </Button>
                            </div>
                        </Col>
                    ))}
                </Row>
            </Form.Item>
        </>)

        const mobileZRender = (text, record) => {
            return (<div>
                <div>{record.zNumber}</div>
                <div style={{ fontSize: 12, color: "gray" }}>
                    מ  {this.formatDateDow(record.minDatetime)}<br />
                    {moment(record.minDatetime).format("HH:mm")}<br />
                    עד  {this.formatDateDow(record.maxDatetime)}<br />
                    {moment(record.maxDatetime).format("HH:mm")}
                </div>
            </div>)
        }

        const mobileSumHRender = (text, record) => {
            return (<div>
                <div>{this.formatSum(record.sumH)}</div>
                <div style={{ fontSize: 12, color: "gray" }}>
                    ({this.formatQty(record.qtyH)})
                </div>
            </div>)
        }

        const mobileSumZRender = (text, record) => {
            return (<div>
                <div>{this.formatSum(record.sumZ)}</div>
                <div style={{ fontSize: 12, color: "gray" }}>
                    ({this.formatQty(record.qtyZ)})
                </div>
            </div>)
        }

        const { _centralType, _splitType } = this.state.modalReportParams ?? {}

        let reportParams = { ...this.state.modalReportParams }
        if (_splitType == '1') {
            reportParams.reportName = "reports/TipsDisplayPerDate" + (_centralType == '3' ? "Detailed" : "") + ".pdf"
        } else if (_splitType == '2') {
            reportParams.reportName = "reports/TipsDisplayPerZBranch" + (_centralType == '3' ? "Detailed" : "") + ".pdf"
        } else if (_splitType == '3' && _centralType == '3') {
            reportParams.reportName = "reports/TipsDisplayPerDateDetailed.pdf"
        }

        return (
            <div style={divStyle}>

                {this.props.isModalAutoIphone ?
                    <GenericModal
                        visible
                        title={gt(22529)}
                        onCancel={this.props.onCancel}
                        width={window.innerWidth < 600 ? "95%" : 500}
                        footer={[
                            <Button style={{ marginLeft: 5 }} onClick={this.props.onCancel}>{gt(22537)}</Button>,
                            <Button type="primary" disabled={!_branchId} onClick={() => { this.setState({ modalOpen: true }) }}>{gt(22536)}</Button>,
                        ]}
                    >{contentStyle}</GenericModal>
                    : <Card
                        title={<PageToolbar title={gt(22529)} showsearch={false} actionButtons={[{ buttonType: 'print', buttonFunction: () => { this.setState({ modalReport: true }) } }]} />}
                        bordered={true}
                        style={{ width: window.innerWidth < 600 ? "95%" : 500 }}
                        headStyle={{ paddingLeft: 8, paddingRight: 8, marginTop: 4, height: 56 }}
                        actions={[
                            <Button type="primary" disabled={!_branchId} onClick={() => { this.setState({ modalOpen: true }) }}>{gt(22536)}</Button>,
                            <Button onClick={() => this.setState({ _branchId: '', _fromZ: '', _toZ: '' })}>{gt(22537)}</Button>
                        ]}
                    >{contentStyle}</Card>}


                <SelectorZBranchList
                    {...this.props}
                    isModalOnly
                    visible={this.state.inputZFocus !== null}
                    getZListOnOpen={list => { this.setState({ zListData: list }) }}
                    filters={{ zNumber: null, branchId: _branchId }}
                    onChange={obj => {
                        let res = { num: obj.zNumber, start: obj.StartDate, end: obj.EndDate }
                        let from = this.state.inputZFocus === "from" ? res : { num: this.state._fromZ, start: this.state._fromZStart, end: this.state._fromZEnd };
                        let to = this.state.inputZFocus === "to" ? res : { num: this.state._toZ, start: this.state._toZStart, end: this.state._toZEnd };
                        this.zSetValues(from, to, null);
                    }}
                />

                <GenericModal
                    visible={modalOpen}
                    title={<>{gt(22554)} {this.state._branchId} {this.state._branchName}</>}
                    onCancel={() => this.setState({ modalOpen: false })}
                >
                    {modalOpen && <GenericTable
                        {...this.props}
                        tableOnly
                        id={this.id}
                        getApi={this.api.get}
                        filters={{ _branchId, _fromZ, _toZ }}
                        columns={
                            window.innerWidth < 600 ? [
                                { title: gt(22558), dataIndex: 'zNumber', key: 'zNumber', width: '40%', render: mobileZRender },
                                { title: gt(22561), dataIndex: 'sumH', key: 'sumH', width: '20%', render: mobileSumHRender },
                                { title: gt(22563), dataIndex: 'sumZ', key: 'sumZ', width: '20%', render: mobileSumZRender },
                                { title: gt(22565), width: '20%', render: this.renderDetailBtn },
                            ] : [
                                { title: gt(22558), dataIndex: 'zNumber', key: 'zNumber', width: '14%' },
                                { title: gt(22559), dataIndex: 'minDatetime', key: 'minDatetime', width: '14%', render: this.formatDateDow },
                                { title: gt(22560), dataIndex: 'maxDatetime', key: 'maxDatetime', width: '14%', render: this.formatDateDow },
                                { title: gt(22561), dataIndex: 'sumH', key: 'sumH', width: '12%', render: this.formatSum },
                                { title: gt(22562), dataIndex: 'qtyH', key: 'qtyH', width: '12%', render: this.formatQty },
                                { title: gt(22563), dataIndex: 'sumZ', key: 'sumZ', width: '12%', render: this.formatSum },
                                { title: gt(22564), dataIndex: 'qtyZ', key: 'qtyZ', width: '12%', render: this.formatQty },
                                { title: gt(22565), width: '10%', render: this.renderDetailBtn },
                            ]}
                    />}
                </GenericModal>

                <GenericModal
                    visible={modalDetail !== null}
                    title={<>{gt(22573)} {modalDetail?.zNumber}</>}
                    onCancel={() => this.setState({ modalDetail: null })}
                    width={1000}
                >
                    {modalDetail && <GenericTable
                        {...this.props}
                        tableOnly
                        id={this.detail_id}
                        getApi={this.api.get_detail}
                        filters={{ zNumber: modalDetail.zNumber }}
                        columns={[
                            { title: gt(22567), dataIndex: 'dTimestamp', key: 'dTimestamp', width: '15%', render: this.formatDateTime },
                            { title: gt(22568), dataIndex: 'dNumber', key: 'dNumber', width: '15%' },
                            { title: gt(22569), dataIndex: 'dCustName', key: 'dCustName', width: '25%' },
                            { title: gt(22570), dataIndex: 'dSum', key: 'dSum', width: '15%', render: this.formatSum },
                            { title: gt(22571), dataIndex: 'dEmployeeName', key: 'dEmployeeName', width: '20%' },
                            { title: gt(22572), width: '10%', render: this.renderViewDocBtn },
                        ]}
                        percentageToMobile={[37, 0, 37, 26]}
                    />}
                </GenericModal>

                <GenericModal
                    visible={modalViewDoc !== null}
                    title={gt(22574) + " " + modalViewDoc?.[0]?.dRef2}
                    onCancel={() => this.setState({ modalViewDoc: null })}
                    width={800}
                >
                    {modalViewDoc && <ResponsiveTable
                        {...this.props}
                        tableOnly
                        dataSource={modalViewDoc}
                        columns={[
                            { title: gt(22567), dataIndex: 'dTimestamp', key: 'dTimestamp', width: '20%', render: this.formatDateTime },
                            { title: gt(22568), dataIndex: 'dNumber', key: 'dNumber', width: '20%' },
                            { title: gt(22569), dataIndex: 'dCustName', key: 'dCustName', width: '30%' },
                            { title: gt(22570), dataIndex: 'dSum', key: 'dSum', width: '20%', render: this.formatSum },
                            { title: gt(22572), width: '10%', render: this.renderShowBtn },
                        ]}
                    />}
                </GenericModal>
                <GenericModal
                    visible={this.state.modalViewList != null}
                    onCancel={() => { this.setState({ modalViewList: null }) }}
                    title={this.state.modalViewList ? `${this.state._branchId} - ${this.state._branchName} - ${this.state.modalViewList.zNumber}` : ""}
                    width={800} >
                    <ResponsiveTable
                        tableOnly
                        dataSource={this.props.data[this.id_list].dataset}
                        columns={[
                            { title: gt(22048), key: "id", dataIndex: "id", width: "10%", render: t => t },
                            { title: gt(22049), key: "name", dataIndex: "name", width: "30%", render: t => t },
                            { title: gt(22050), key: "min", dataIndex: "min", width: "25%", render: this.formatDateTime },
                            { title: gt(22051), key: "max", dataIndex: "max", width: "25%", render: this.formatDateTime },
                            { title: "", key: "types", dataIndex: "types", width: "10%", render: (t, r) => (<Tooltip title={gt(22052)}><Icon type="table" onClick={() => { this.setState({ modalDetails: r }) }} /></Tooltip>) },
                        ]}
                    />
                </GenericModal>
                <GenericModal
                    visible={this.state.modalDetails != null}
                    onCancel={() => { this.setState({ modalDetails: null }) }}
                    title={this.state.modalDetails ? `${this.state.modalDetails.id} - ${this.state.modalDetails.name}` : ""}
                    width={700}
                >
                    <ResponsiveTable
                        tableOnly
                        dataSource={this.state.modalDetails?.types ?? []}
                        columns={[
                            { title: gt(22053), key: "_TypeID", dataIndex: "_TypeID", width: "12%", render: t => t },
                            { title: gt(22054), key: "_TypeName", dataIndex: "_TypeName", width: "36%", render: t => t },
                            { title: gt(22050), key: "_minTimestamp", dataIndex: "_minTimestamp", width: "26%", render: this.formatDateTime },
                            { title: gt(22051), key: "_maxTimestamp", dataIndex: "_maxTimestamp", width: "26%", render: this.formatDateTime },
                        ]}
                    />
                </GenericModal>
                <GenericModal
                    visible={this.state.modalReport}
                    onCancel={() => { this.setState({ modalReport: false }) }}
                    title={gt(22807)}
                    width={700}
                >
                    <Form.Item label={gt(22808)}>
                        <GenericSelector
                            {...this.props}
                            {...this.selectors[0]}
                            multi
                            value={this.state.modalReportParams?._employeeList ? this.state.modalReportParams?._employeeList.split(",") : []}
                            onChange={(e) => {
                                this.setState({ modalReportParams: { ...this.state.modalReportParams, _employeeList: e ? e.join(",") : "" } })
                            }}
                        />
                    </Form.Item>
                    <Form.Item label={gt(22809)}>
                        <GenericSelector
                            {...this.props}
                            {...this.selectors[1]}
                            multi
                            value={this.state.modalReportParams?._tablesList ? this.state.modalReportParams?._tablesList.split(",") : []}
                            onChange={(e) => {
                                this.setState({ modalReportParams: { ...this.state.modalReportParams, _tablesList: e ? e.join(",") : "" } })
                            }}
                        />
                    </Form.Item>
                    <Row>
                        <Col span={window.innerWidth < 600 ? 24 : 12}>
                            <Form.Item label={gt(22810)}>
                                <InputNumber
                                    value={this.state.modalReportParams?._fromSum}
                                    onChange={(e) => {
                                        this.setState({ modalReportParams: { ...this.state.modalReportParams, _fromSum: e } })
                                    }}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={window.innerWidth < 600 ? 24 : 12}>
                            <Form.Item label={gt(22811)}>
                                <InputNumber
                                    value={this.state.modalReportParams?._toSum}
                                    onChange={(e) => {
                                        this.setState({ modalReportParams: { ...this.state.modalReportParams, _toSum: e } })
                                    }}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={window.innerWidth < 600 ? 24 : 12}>
                            <Form.Item label={gt(22812)}>
                                <Radio.Group
                                    value={this.state.modalReportParams?._centralType}
                                    onChange={(e) => {
                                        this.setState({ modalReportParams: { ...this.state.modalReportParams, _centralType: e.target.value } })
                                    }}
                                >
                                    <Radio value="1">{gt(22814)}</Radio><br />
                                    <Radio value="2">{gt(22815)}</Radio><br />
                                    <Radio value="3">{gt(22816)}</Radio>
                                </Radio.Group>
                            </Form.Item>
                        </Col>
                        <Col span={window.innerWidth < 600 ? 24 : 12}>
                            <Form.Item label={gt(22813)}>
                                <Radio.Group
                                    value={this.state.modalReportParams?._splitType}
                                    onChange={(e) => {
                                        this.setState({ modalReportParams: { ...this.state.modalReportParams, _splitType: e.target.value } })
                                    }}
                                >
                                    <Radio value="1">{gt(22817)}</Radio><br />
                                    <Radio value="2">{gt(22818)}</Radio><br />
                                    <Radio value="3">{gt(22819)}</Radio>
                                </Radio.Group>
                            </Form.Item>
                        </Col>
                    </Row>
                    <ReportTypeButton
                        {...this.props}
                        params={reportParams}
                        favoriteSave
                        xlsReportName={"reports/TipsDisplayExcel.xls"}
                    />
                </GenericModal>
            </div>
        );
    }
}

export default TipsDisplay;